<template>
  <div class="question">
    <div class="item">
      {{
        $G("Milky Cloud承诺所售商品均为澳洲原装正品，并承诺提供“正品保障”服务。")
      }}
    </div>
    <div class="item">
      {{
        $G(
          "在Milky Cloud购物时，若经合法认定买家已购得的商品为假货或非原装正品，买家有权在交易成功后90天内发起投诉，并依据澳大利亚消费者法（Australian Consumer Law）申请“正品保障”赔付，赔付金额以买家实际支付的商品价款及相关邮费为限，"
        )
      }}<span class="item_blod">全额退款</span>。
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    backClick() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.question {
  background: #fff;
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 22px;
  padding: 15px;
  border-top: 1px solid #eee;
}
.item {
  padding-top: 10px;
  text-indent: 25px;
}
.item_blod {
  font-weight: 500;
}
</style>
